import { DatePipe } from '@angular/common';
import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ChipModule } from 'src/shared/ez-chip/chip.module';
import { EzSelectableCardComponent } from 'src/shared/ez-card/ez-selectable-card/ez-selectable-card.component';
import { PolicyCard } from './policy-card';

@Component({
  selector: 'ez-policy-card',
  templateUrl: './policy-card.component.html',
  styleUrls: ['./policy-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EzSelectableCardComponent, ChipModule, MatIconModule, DatePipe],
})
export class PolicyCardComponent {
  protected readonly policy = input.required<PolicyCard>();
  protected readonly selected = input<boolean | undefined>(undefined);
  protected readonly radioMode = input(false, { transform: booleanAttribute });
  protected readonly selectedChange = output<boolean>();

  protected readonly chipColor = computed((): string | null => {
    switch (this.policy().policyStatus) {
      case 'Active': return 'green800';
      case 'Inactive': return 'warn';
      default: return 'indigo400';
    }
  });
}
